import { h, Component } from "preact";
import { Text } from "preact-i18n";

import im from "../img/agromap.png"
class MainServices extends Component {
  render() {

    //const { registerLink } = this.props;

    return (
      <div
        id="aboutus"
        uk-scrollspy="cls: uk-animation-fade; repeat: true"
        class="uk-section uk-section-default uk-section-small"
        style={{ backgroundColor: "#F9F6FA", minHeight: "100vh" }}
      >
        <div style={{ textAlign: "center", paddingTop: "3em" }} >
          <h1>
            <Text id="MainServices.title">
              Sobre
            </Text>
          </h1>
          <h4>
            <Text id="MainServices.subtitle">
              A Agroinsider tem competências e conhecimento próprio para formar técnicos, 
              consultores e agricultores na utilização das novas 
              tecnologias em agricultura.
            </Text>
          </h4>
        </div>

        <div class="uk-container" style={{ paddingTop: "3em" }}>
          <div
            uk-grid
            class="uk-grid-large uk-flex-middle uk-text-center uk-text-left@l uk-grid"
          >

            <div class="" style={{width:"40em", position:"absolute"}}>

              <h4>
                <Text id="MainServices.text1">
                  Nesse sentido, criamos uma formação à distância em Agricultura
                  Inteligente (Agricultura de Precisão), para todo o mundo Lusófono, de
                  como é que qualquer técnico pode observar quaisquer parcelas agrícolas,
                  ou outras do seu interesse, por forma a poder detetar quaisquer tipo de
                  anomalias agronómicas e culturais que possam levar a percas
                  económicas e ambientais, melhorando dessa forma continuamente o seu
                  sistema de produção e a sustentabilidade da sua atividade.
                </Text>
              </h4>

              <h4>
                <Text id="MainServices.text2">
                  Não fique para trás no comboio tecnológico da agricultura e aprenda connosco.
                  Incluído no preço da formação tenha acesso a uma conta profissional da
                  Agroinsider de forma a poder meter as mãos na massa monitorizando e 
                  inspecionando de forma muito prática uma área até 500 ha. Com a 
                  formação realizada pode associar-se ao painel de consultores acreditado 
                  da Agroinsider (Market Place Agroinsider).
                </Text>
              </h4>


              <div
                uk-grid=""
                class="uk-grid-medium uk-flex-middle uk-flex-center uk-grid"
              >

                <div class="uk-first-column">
                  <a
                    //href={registerLink}
                    href="#contactus"
                    uk-scroll
                    onClick={e => this.scrollMe(e, "contactus")}
                  >
                    <button
                      class="uk-button uk-button-primary uk-width-4-4 uk-margin-small-bottom"
                      disabled={this.state.success ? true : false}
                    >
                      <Text id="MainServices.register">Inscrever-se</Text>
                    </button>
                  </a>
                </div>
                <div>
                  <a
                    href="#howto"
                    uk-scroll
                    onClick={e => this.scrollMe(e, "howto")}
                  >
                    <button
                      class="uk-button uk-button-primary uk-width-4-4 uk-margin-small-bottom"
                      disabled={this.state.success ? true : false}
                    >
                      <Text id="MainServices.learn">Conteúdos</Text>
                    </button>
                  </a>
                </div>
              </div>
            </div>


            <div class="" style={{width:"50em", position:"relative", left:"600px", bottom:"50px"}}>
              <img src={im} />
            </div>
          </div>

        </div>

      </div>
    );
  }
}

export default MainServices;
